module.exports = __webpack_public_path__ + "static/img/伙伴客户-贵州农社.55b51938.png";